import { render, staticRenderFns } from "./InvitationTokenTemplate.vue?vue&type=template&id=227335f5&scoped=true&"
import script from "./InvitationTokenTemplate.vue?vue&type=script&lang=js&"
export * from "./InvitationTokenTemplate.vue?vue&type=script&lang=js&"
import style0 from "./InvitationTokenTemplate.vue?vue&type=style&index=0&id=227335f5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227335f5",
  null
  
)

export default component.exports